import React, {useEffect, useState} from 'react';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {
    Checkbox, Container,
    FilledInput,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel, Link, MenuItem, Paper, Radio,
    RadioGroup, Select, TextField,
    Typography
} from "@mui/material";
import {DatePicker, MobileDatePicker} from '@mui/x-date-pickers';
import SecondaryButton from "../../Common/SecondaryButton";
import PrimaryButton from "../../Common/PrimaryButton";
import {Form} from "formik";
import {makeStyles} from "@mui/styles";
import "./datePicker.scss";
// import DiveBanner from "../../../../img/DiveInsurance1.png";
import {useSelector} from "react-redux";
import {Link as RouterLink, useHistory} from "react-router-dom";
import {differenceInDays, parse} from "date-fns";

const useStyles = makeStyles((theme) => ({
    sectionHeading: {
        fontSize: '2.4rem',
        fontWeight: '600',
        marginBottom: '20px',
    },
    sectionTitle: {
        fontSize: '1.6rem',
        fontWeight: '600',
        marginBottom: '10px',
    },
    noteContainer: {
        marginLeft: '10px',
        marginRight: '10px',
        paddingTop: '20px',
        marginBottom: '20px',
    },
    formSection: {
        marginBottom: '20px',
    },
    checkboxLabel: {
        fontSize: '1.4rem',
    },
    infoContainer: {
        backgroundColor: theme.palette.lightBlue.main,
        paddingBottom: '20px',
    },
    insuranceBanner: {
        marginTop: '30px',
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        borderRadius: 0,
    },
    insuranceTitle: {
        fontSize: '2.4rem',
        fontWeight: 600,
        marginBottom: '20px',
        letterSpacing: '1.2px',
    },
    insuranceDescription: {
        fontSize: '1.6rem',
        fontWeight: 400,
        textAlign: 'left',
    },
}));

const MedicalAndInsuranceForm = ({values, handleChange, setFieldValue}) => {
    const classes = useStyles();
    const [responsive, setResponsive] = useState(false);
    const {booking} = useSelector(state => state.bookingForm);
    const history = useHistory();

    const boardDate = parse(booking.trip.boarddate, 'yyyy-MM-dd', new Date());
    const daysBeforeBoardDate = differenceInDays(boardDate, new Date());
    // const disableInputs = daysBeforeBoardDate < 8;
    const disableInputs = false ;

    useEffect(() => {
        checkResponsive();
        window.addEventListener('resize', checkResponsive, true);
    }, []);

    const checkResponsive = () => {
        const width = window.innerWidth;
        if (width < 700) setResponsive(true);
        else setResponsive(false);
    };

    const goToInsurancePage = () => {
        const url = 'https://diveassure.com/en-intl/home/?pid=6776';
        window.open(url, '_blank');
    };

    return (
        <Form>
            <Grid container sx={{px: {xs: '1.6rem', lg: '0'}}}>
                <Typography variant="h3" className={classes.sectionHeading}>
                    Emergency Contact<span style={{color: 'red'}}>*</span>
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                        <Grid container spacing={3} className={classes.formSection}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" className={classes.sectionTitle}>Name</Typography>
                                <FormControl variant="filled" fullWidth>
                                    <InputLabel htmlFor="emergContact">Name</InputLabel>
                                    <FilledInput id="emergContact" name="emergContact"
                                                 value={values.emergContact}
                                                 disabled={disableInputs}
                                                 onChange={handleChange} disableUnderline/>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" className={classes.sectionTitle}>Phone</Typography>
                                <FormControl variant="filled" fullWidth>
                                    <InputLabel htmlFor="emergPhone">Phone</InputLabel>
                                    <FilledInput id="emergPhone" name="emergPhone"
                                                 value={values.emergPhone}
                                                 disabled={disableInputs}
                                                 onChange={handleChange} disableUnderline/>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" className={classes.sectionTitle}>Relationship</Typography>
                                <FormControl variant="filled" fullWidth>
                                    <InputLabel htmlFor="emergRelation">Relationship</InputLabel>
                                    <FilledInput id="emergRelation" name="emergRelation"
                                                 value={values.emergRelation}
                                                 disabled={disableInputs}
                                                 onChange={handleChange} disableUnderline/>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Typography variant="h3" className={classes.sectionHeading}>
                            Dietary & Medical Information
                        </Typography>
                        <Grid container spacing={3} className={classes.formSection}>
                            <Grid item xs={12} md={6} style={{display: 'flex', alignItems: 'center'}}>
                                <Typography variant="h5" className={classes.sectionTitle} style={{marginBottom: 0}}>
                                    Please select your desired menu<span style={{color: 'red'}}>*</span>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl variant="filled" fullWidth>
                                    <InputLabel id="menuLabel">Menu</InputLabel>
                                    <Select
                                        labelId="menuLabel"
                                        id="menu"
                                        name="menu"
                                        label="Menu"
                                        value={values.menu}
                                        onChange={handleChange}
                                        disabled={disableInputs}
                                        disableUnderline
                                    >
                                        <MenuItem value={'regular'}>Regular/Normal</MenuItem>
                                        <MenuItem value={'vegetarian'}>Vegetarian</MenuItem>
                                        <MenuItem value={'vegan'}>Vegan</MenuItem>
                                        <MenuItem value={'glutenfree'}>Gluten Free</MenuItem>
                                        <MenuItem value={'kosher'}>Kosher</MenuItem>
                                        <MenuItem value={'pescatarian'}>Pescatarian</MenuItem>

                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} className={classes.formSection}>
                            <Grid item xs={12} md={12}>
                                <FormControlLabel
                                    control={<Checkbox id="hasAllergies" name="allergyYesNo" onChange={handleChange}
                                                       disabled={disableInputs}
                                                       checked={values.allergyYesNo}/>}
                                    label="I have allergies (e.g. sulpha drugs, penicillin, food, etc.)">
                                </FormControlLabel>
                            </Grid>
                            {values.allergyYesNo && <Grid item xs={12} md={12}>
                                <FormControl variant="filled" fullWidth>
                                    <InputLabel htmlFor="allergies">Please specify.</InputLabel>
                                    <FilledInput id="allergies" name="allergies"
                                                 value={values.allergies} multiline minRows={3}
                                                 disabled={disableInputs}
                                                 onChange={handleChange} disableUnderline/>
                                </FormControl>
                            </Grid>}
                            <Grid item xs={12} md={12}>
                                <FormControlLabel
                                    control={<Checkbox id="medicalRequirements" name="medicalYesNo"
                                                       onChange={handleChange}
                                                       disabled={disableInputs}
                                                       checked={values.medicalYesNo}/>}
                                    label="Do you have any special medical requirements?">
                                </FormControlLabel>
                            </Grid>
                            {values.medicalYesNo && <Grid item xs={12} md={12}>
                                <FormControl variant="filled" fullWidth>
                                    <InputLabel htmlFor="medical">Please specify.</InputLabel>
                                    <FilledInput id="medical" name="medical" disabled={disableInputs}
                                                 value={values.medical} multiline minRows={3}
                                                 onChange={handleChange} disableUnderline/>
                                </FormControl>
                            </Grid>}
                        </Grid>

                        {booking?.trip?.location?.tripTypeFk !== 2 ? <>
                                <Typography variant="h3" className={classes.sectionHeading}>
                                    Dive Insurance
                                </Typography>
                                <Grid container spacing={3} className={classes.formSection}>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="h5" className={classes.sectionTitle}>Agency</Typography>
                                        <FormControl variant="filled" fullWidth>
                                            <InputLabel htmlFor="diveInsProvider">Agency</InputLabel>
                                            <FilledInput id="diveInsProvider" name="diveInsProvider"
                                                         value={values.diveInsProvider}
                                                         disabled={disableInputs}
                                                         onChange={handleChange} disableUnderline/>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="h5" className={classes.sectionTitle}>Dive Insurance
                                            Number</Typography>
                                        <FormControl variant="filled" fullWidth>
                                            <InputLabel htmlFor="diveInsNum">Dive Insurance Number</InputLabel>
                                            <FilledInput id="diveInsNum" name="diveInsNum"
                                                         value={values.diveInsNum}
                                                         disabled={disableInputs}
                                                         onChange={handleChange} disableUnderline/>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3} className={classes.formSection}>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="h5" className={classes.sectionTitle}>
                                            Expiration Date
                                        </Typography>
                                        <FormControl variant="filled" fullWidth>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                {!responsive ? (<DatePicker
                                                    label="YYYY-MM-DD"
                                                    value={values.diveInsExpiryDate}
                                                    onChange={(date) => setFieldValue('diveInsExpiryDate', date)}
                                                    renderInput={(params) => <TextField {...params} variant="filled"/>}
                                                    disabled={disableInputs}
                                                    inputFormat="yyyy-MM-dd"
                                                    mask="____-__-__"
                                                />) : (<MobileDatePicker
                                                    label="YYYY-MM-DD"
                                                    value={values.diveInsExpiryDate}
                                                    onChange={(date) => setFieldValue('diveInsExpiryDate', date)}
                                                    renderInput={(params) => <TextField {...params} variant="filled"/>}
                                                    disabled={disableInputs}
                                                    inputFormat="yyyy-MM-dd"
                                                    mask="____-__-__"
                                                />)}
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </> :
                            <>
                                <Typography variant="h3" className={classes.sectionHeading}>
                                    Medical Evacuation Insurance <span style={{color: 'red'}}>(Mandatory)</span>
                                </Typography>
                                <Grid container spacing={3} className={classes.formSection}>
                                    <Grid item xs={12} md={12}>
                                        <Typography className={classes.insuranceDescription}>
                                            Because of the remote location of the camp, medical evacuation insurance is required for all guests. We can assist with a purchase of the insurance and it's very affordable.<a href="https://diveassure.com/en/whale-adventures-trip-coverage/">Click Here</a>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="h5" className={classes.sectionTitle}>Insurance
                                            Agency</Typography>
                                        <FormControl variant="filled" fullWidth>
                                            <InputLabel htmlFor="diveInsProvider">Insurance Agency</InputLabel>
                                            <FilledInput id="diveInsProvider" name="diveInsProvider"
                                                         value={values.diveInsProvider}
                                                         disabled={disableInputs}
                                                         onChange={handleChange} disableUnderline/>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="h5" className={classes.sectionTitle}>Insurance
                                            Number</Typography>
                                        <FormControl variant="filled" fullWidth>
                                            <InputLabel htmlFor="diveInsNum">Insurance Number</InputLabel>
                                            <FilledInput id="diveInsNum" name="diveInsNum"
                                                         value={values.diveInsNum}
                                                         disabled={disableInputs}
                                                         onChange={handleChange} disableUnderline/>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3} className={classes.formSection}>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="h5" className={classes.sectionTitle}>
                                            Policy Expiration Date
                                        </Typography>
                                        <FormControl variant="filled" fullWidth>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                {!responsive ? (<DatePicker
                                                    label="YYYY-MM-DD"
                                                    value={values.diveInsExpiryDate}
                                                    onChange={(date) => setFieldValue('diveInsExpiryDate', date)}
                                                    renderInput={(params) => <TextField {...params} variant="filled"/>}
                                                    disabled={disableInputs}
                                                    inputFormat="yyyy-MM-dd"
                                                    mask="____-__-__"
                                                />) : (<MobileDatePicker
                                                    label="YYYY-MM-DD"
                                                    value={values.diveInsExpiryDate}
                                                    onChange={(date) => setFieldValue('diveInsExpiryDate', date)}
                                                    renderInput={(params) => <TextField {...params} variant="filled"/>}
                                                    disabled={disableInputs}
                                                    inputFormat="yyyy-MM-dd"
                                                    mask="____-__-__"
                                                />)}
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </>}
                    </Grid>
                </Grid>
            </Grid>

            {booking?.trip?.location?.tripTypeFk !== 2 && <>
                <Paper className={classes.insuranceBanner}>
                    <Grid container>
                        <Grid item xs={12} md={2}>
                            <div style={{
                                height: '100%',
                                width: '100%',
                                background: 'url(../../../../images/DiveInsurance1.png) no-repeat center center',
                                backgroundSize: 'cover'
                            }}/>
                        </Grid>
                        <Grid item xs={12} md={2} style={{padding: '10px'}}>
                            <img src={`${window['appBasename']}/images/DiveAssure.jpg`} alt={'Insurance'}/>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Container style={{height: '100%'}}>
                                <Grid container style={{height: '100%'}}>
                                    <Grid item xs={12} md={8}>
                                        <div style={{marginTop: '20px', marginLeft: '10px'}}>
                                            <Typography variant={'h3'} className={classes.insuranceTitle}>
                                                No Diving Insurance Yet?
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '100%'
                                        }}>
                                            <PrimaryButton style={{width: 'auto'}} onClick={goToInsurancePage}>
                                                Get Yours Now
                                            </PrimaryButton>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Grid>
                    </Grid>
                </Paper>
            </>}
                <div style={{marginTop: '30px'}}>
                    <Typography variant="h3" className={classes.sectionHeading}>
                        Travel Insurance
                    </Typography>
                    <Typography className={classes.sectionDescription}>
                        {booking?.trip?.location?.tripTypeFk !== 2 ? 'Travel insurance is different than Diving Insurance which provides medical cover, medieval, chamber treatment and so on.':''}
                        We highly recommend the additional purchase of Travel Insurance
                        which can provide cover against trip interruption, trip cancellation, cancelled airline flights
                        and much more covering situations such as named storms, trip interruption because another guest
                        requires medical attention, government order preventing the ship from sailing.
                    </Typography>
                    <Grid container spacing={3} className={classes.formSection}>
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <RadioGroup name="travelIns" value={values.travelIns}
                                            disabled={disableInputs}
                                            onChange={handleChange}>
                                    <Container>
                                        <FormControlLabel value="other" control={<Radio id="insOther" disabled={disableInputs} />}
                                                          label=""/>
                                        <label htmlFor="insOther">I have trip insurance.</label>
                                    </Container>

                                {values.travelIns === 'other' && <FormControl variant="filled" fullWidth>
                                    <InputLabel htmlFor="insuranceProvider">Insert Policy Name</InputLabel>
                                    <FilledInput id="insuranceProvider" name="insuranceProvider"
                                                 value={values.insuranceProvider}
                                                 disabled={false}
                                                 onChange={handleChange} disableUnderline/>
                                </FormControl>}

                                    <Container>
                                        <FormControlLabel value="yes" control={<Radio id="insYes" disabled={disableInputs} />}
                                                          label=""/>
                                        <label htmlFor="insYes">We highly recommend trip interruption and travel insurance. </label>
                                        <Link underline="hover" color="inherit" target='_blank' href="https://diveassure.com/en/whale-adventures-trip-coverage/">
                                            Click here to purchase
                                        </Link>
                                    </Container>
                                    <Container>
                                        <FormControlLabel value="no" control={<Radio id="insRadioNo" disabled={disableInputs} />}
                                                          label=""/>
                                        <label htmlFor="insRadioNo">I decline to purchase travel insurance and
                                            understand that I am wholly
                                            responsible for any costs incurred because of a trip that is shortened or
                                            cancelled
                                            for reasons beyond the control of Nautilus including missed flights,
                                            missed dives because of named storms, medical issues or mechanical
                                            problems</label>
                                    </Container>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>


            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '75px'}}>
                <SecondaryButton onClick={() => history.goBack()} style={{margin: 0}}>Back</SecondaryButton>
                <PrimaryButton style={{margin: 0}} type="submit">Next</PrimaryButton>
            </div>
        </Form>
    );
};

export default MedicalAndInsuranceForm;